import { SessionStoragePersistence } from "utils/Persistence"
import EncounterDataReader from "./EncounterDataReader"
import PatientDataReader from "./PatientDataReader"
import SubmitterDataReader from "./SubmitterDataReader"
import { ENCOUNTER_QUESTION_TAGS } from "./encounterQuestionTags"
import { PATIENT_QUESTION_TAGS } from "./patientQuestionTags"
import { SUBMITTER_QUESTION_TAGS } from "./submitterQuestionTags"

const KEY = "fhir"

function persistValue(fhirResourceReader, questionTag) {
  SessionStoragePersistence.persist({
    key: KEY,
    property: questionTag,
    value: fhirResourceReader[questionTag],
  })
}

function persistFhirResourceForQuestionTags(fhirResourceReader, questionTags) {
  questionTags.forEach((questionTag) => {
    persistValue(fhirResourceReader, questionTag)
  })
}

const FHIRPersistence = {
  allData() {
    return SessionStoragePersistence.getValue({ key: KEY })
  },

  clear() {
    SessionStoragePersistence.clear({ key: KEY })
  },

  lookup(property) {
    return SessionStoragePersistence.lookup({ key: KEY, property })
  },

  persistEncounter(fhirEncounterData, ehrName) {
    persistFhirResourceForQuestionTags(
      new EncounterDataReader(fhirEncounterData, ehrName),
      ENCOUNTER_QUESTION_TAGS,
    )
  },

  persistPatient(fhirPatientData, ehrName) {
    persistFhirResourceForQuestionTags(
      new PatientDataReader(fhirPatientData, ehrName),
      PATIENT_QUESTION_TAGS,
    )
  },

  persistSubmitter(fhirPractitionerData, ehrName) {
    persistFhirResourceForQuestionTags(
      new SubmitterDataReader(fhirPractitionerData, ehrName),
      SUBMITTER_QUESTION_TAGS,
    )
  },
}

export default FHIRPersistence
